/**
 * Values shared with consumers that do not render the plans list.
 *
 * They live apart from PlansList.tsx so that reading an enum member or building a query key does
 * not pull in the plans page. Being runtime values rather than types, `import type` cannot do this
 * job - keep them free of imports that reach the page.
 */

export enum SharePlanType {
    PLANS = 0,
    SET = 1,
    PAGE = 2,
}

export function getPlansListQueryKey(jobId: number | undefined) {
    return ["plans", jobId];
}
